import { Link, useLocation } from 'react-router-dom'
import { Home, Search, Plus, Heart, Menu, Gem } from 'lucide-react'
import { PATHS } from '@/routes/paths'
import { useUiStore } from '@/store/uiStore'
import { cn } from '@/lib/utils'
import { trackPostPropertyClick } from '@/lib/analytics/sellerEvents'

export function MobileNav() {
  const { pathname } = useLocation()
  const { isSearchOpen, isMobileMenuOpen, setSearchOpen, setMobileMenuOpen } = useUiStore()

  const openSearch = () => {
    setMobileMenuOpen(false)
    setSearchOpen(true)
  }

  const openMenu = () => {
    setSearchOpen(false)
    setMobileMenuOpen(true)
  }

  const isHome = pathname === PATHS.home
  const isActivity =
    pathname.startsWith(PATHS.dashboard) ||
    pathname.startsWith(PATHS.myInquiry) ||
    pathname.startsWith(PATHS.myProperty)
  const isPost = pathname.startsWith(PATHS.addProperty)
  const isPremium = pathname.startsWith(PATHS.premium)

  return (
    <nav
      className={cn(
        'fixed bottom-0 left-0 right-0 z-40 border-t border-neutral-200 bg-white md:hidden safe-bottom',
        (isSearchOpen || isMobileMenuOpen) && 'hidden',
      )}
    >
      <div className="grid grid-cols-5 items-end px-1 pb-1.5 pt-1">
        <Link
          to={PATHS.home}
          onClick={() => {
            setSearchOpen(false)
            setMobileMenuOpen(false)
          }}
          className={cn(
            'flex flex-col items-center gap-0.5 py-1.5 text-[10px] font-semibold',
            isHome ? 'text-neutral-900' : 'text-neutral-500',
          )}
        >
          <Home className={cn('h-5 w-5', isHome && 'stroke-[2.5]')} />
          Home
        </Link>

        {isHome ? (
          <Link
            to={PATHS.premium}
            onClick={() => {
              setSearchOpen(false)
              setMobileMenuOpen(false)
            }}
            className={cn(
              'flex flex-col items-center gap-0.5 py-1.5 text-[10px] font-semibold',
              isPremium ? 'text-neutral-900' : 'text-neutral-500',
            )}
          >
            <Gem className={cn('h-5 w-5', isPremium && 'stroke-[2.5]')} />
            Premium
          </Link>
        ) : (
          <button
            type="button"
            onClick={openSearch}
            className={cn(
              'flex flex-col items-center gap-0.5 py-1.5 text-[10px] font-semibold',
              isSearchOpen ? 'text-neutral-900' : 'text-neutral-500',
            )}
          >
            <Search className={cn('h-5 w-5', isSearchOpen && 'stroke-[2.5]')} />
            Search
          </button>
        )}

        <Link
          to={PATHS.addProperty}
          onClick={() => {
            trackPostPropertyClick('mobile_nav')
            setSearchOpen(false)
            setMobileMenuOpen(false)
          }}
          className="relative flex flex-col items-center gap-0.5 py-0.5"
        >
          <span
            className={cn(
              'relative flex h-10 w-10 items-center justify-center rounded-lg border-2 shadow-sm',
              isPost
                ? 'border-primary-600 bg-primary-600 text-white'
                : 'border-primary-200 bg-primary-50 text-primary-700',
            )}
          >
            <Plus className="h-5 w-5" />
            <span className="absolute -right-1.5 -top-1.5 rounded bg-success-500 px-1 py-px text-[7px] font-bold uppercase text-white">
              Free
            </span>
          </span>
          <span className={cn('text-[10px] font-semibold', isPost ? 'text-neutral-900' : 'text-neutral-500')}>
            Post
          </span>
        </Link>

        <Link
          to={PATHS.dashboard}
          onClick={() => {
            setSearchOpen(false)
            setMobileMenuOpen(false)
          }}
          className={cn(
            'flex flex-col items-center gap-0.5 py-1.5 text-[10px] font-semibold',
            isActivity ? 'text-neutral-900' : 'text-neutral-500',
          )}
        >
          <Heart className={cn('h-5 w-5', isActivity && 'fill-neutral-900 stroke-neutral-900')} />
          Activity
        </Link>

        <button
          type="button"
          onClick={openMenu}
          className={cn(
            'flex flex-col items-center gap-0.5 py-1.5 text-[10px] font-semibold',
            isMobileMenuOpen ? 'text-neutral-900' : 'text-neutral-500',
          )}
        >
          <Menu className={cn('h-5 w-5', isMobileMenuOpen && 'stroke-[2.5]')} />
          Menu
        </button>
      </div>
    </nav>
  )
}
